// src/plugins/index.js

import vuetify from './vuetify'
import router from '@/router'  // This uses the router defined above

export function registerPlugins(app) {
  app
    .use(vuetify)
    .use(router)
}
